/* eslint-disable react/prop-types */
import React from 'react';
import Modal from 'react-modal';
import styles from './Popup.module.css';
import CloseButton from '../buttons/CloseButton';

Modal.setAppElement('#root');

function Popup({
  isOpen,
  closePopup,
  children,
  height,
  noScroll,
  overflow = 'hidden',
  noClose = false,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={noClose ? () => {} : closePopup}
      style={{
        content: {
          inset: '1px',
          background: 'var(--color-surface-elevated)',
          borderRadius: 'var(--radius-2xl)',
          margin: 'auto',
          padding: '0px',
          display: 'flex',
          alignItems: 'center',
          height: height || 'fit-content',
          width: 'fit-content',
          boxSizing: 'border-box',
          border: '1px solid var(--color-border)',
          boxShadow: 'var(--shadow-md)',
        },
        overlay: {
          backgroundColor: 'var(--popup-overlay)',
          cursor: 'pointer',
        },
      }}
    >
      <div
        className={styles.scrollableContent}
        style={{
          height: noScroll ? '100%' : 'fit-content',
          overflow,
          cursor: 'default',
        }}
      >
        {!noClose && (
          <div style={{
            position: 'absolute',
            right: '10px',
            top: '10px',
          }}
          >
            <CloseButton onClick={closePopup} />
          </div>
        )}
        <div
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 'var(--space-md)',
            width: 'fit-content',
          }}
        >

          {children}
        </div>
      </div>
    </Modal>
  );
}

export default Popup;
